import React, { Component } from "react";
import {Link} from 'react-router-dom';

export class AdminMenuList extends Component {
  render() {

    let location = window.location.href.split('/')[window.location.href.split('/').length - 1];

    //console.log(location);

    const dashboardClass = location === "dashboard" ? "btn w-100 text-left check-hover py-3 bg-transparent router-link-exact-active router-link-active btn-secondary" : "btn w-100 text-left check-hover py-3 bg-transparent btn-secondary";
    
    const evestClass = location === "evest-list" ? "btn w-100 text-left check-hover py-3 bg-transparent router-link-exact-active router-link-active btn-secondary" : "btn w-100 text-left check-hover py-3 bg-transparent btn-secondary";
    

    const usersClass = location === "users-list" ? "btn w-100 text-left check-hover py-3 bg-transparent router-link-exact-active router-link-active btn-secondary" : "btn w-100 text-left check-hover py-3 bg-transparent btn-secondary";
    
    const landvestClass = location === "landvest-list" ? "btn w-100 text-left check-hover py-3 bg-transparent router-link-exact-active router-link-active btn-secondary" : "btn w-100 text-left check-hover py-3 bg-transparent btn-secondary";


    const plansClass = location === "my-plans" ? "btn w-100 text-left check-hover py-3 bg-transparent router-link-exact-active router-link-active btn-secondary" : "btn w-100 text-left check-hover py-3 bg-transparent btn-secondary";


    const accountClass = location === "my-account" ? "btn w-100 text-left check-hover py-3 bg-transparent router-link-exact-active router-link-active btn-secondary" : "btn w-100 text-left check-hover py-3 bg-transparent btn-secondary";


    return (
      <div>
        <ul className="list-unstyled">
          <li>
            <Link
              to="/admin/dashboard"
              className={dashboardClass}
            >
              <i className="mr-1 ti-dashboard"></i> Dashboard
            </Link>
          </li>
          <li>
            <Link
              to="/admin/users-list"
              className={usersClass}
            >
              <i className="mr-1 ti-list"></i> Users Listing
            </Link>
          </li>
          <li>
            <Link
              to="/admin/evest-list"
              className={evestClass}
            >
              <i className="mr-1 ti-home"></i> EVest Homes
            </Link>
          </li>
          <li>
            <Link
              to="/admin/landvest-list"
              className={landvestClass}
            >
              <i className="mr-1 ti-map"></i> LandVest Lands
            </Link>
          </li>
          <li>
            <Link
              to="/admin/my-account"
              className={accountClass}
            >
              <i className="mr-1 ti-user"></i> Admin Profile
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}

export default AdminMenuList;
